export default __webpack_public_path__ + "static/media/longshirtArcelikBayi.03204ba2.jpg";